__turbopack_context__.v({
  "card": "select-boat-card-module-scss-module__WRrPzq__card",
  "cardCover": "select-boat-card-module-scss-module__WRrPzq__cardCover",
  "cardWrapper": "select-boat-card-module-scss-module__WRrPzq__cardWrapper",
  "checkmark": "select-boat-card-module-scss-module__WRrPzq__checkmark",
  "selectedCardWrapper": "select-boat-card-module-scss-module__WRrPzq__selectedCardWrapper",
  "textContainer": "select-boat-card-module-scss-module__WRrPzq__textContainer",
  "textStyle": "select-boat-card-module-scss-module__WRrPzq__textStyle",
});
